/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Filter, Station, TableSearch } from "../../common/svg/AllSvg";
import NearPlacesFilter from "./NearPlacesFilter";
import SecondaryBtn from "../../common/form/SecondaryBtn";
import { url } from "../../../shared/utils/url";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../shared/hooks/use-axios";
import NoSearch from "../../common/form/NoSearch";
import EmptyList from "../../common/form/EmptyList";
import { sitemap } from "../../../shared/utils/sitemap";
import Error from "../../common/form/Error";
import { useDeviceType } from "../../../shared/utils/useDeviceType";

const NearByPlacesList = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [category, setCategory] = useState<any[]>([])
    const [placesData, setPlacesData] = useState<any[]>([])
    const [data, setData] = useState<any[]>([])
    const [search, setSearch] = useState<string>("")
    const [debouncedValue, setDebouncedValue] = useState<string>(search);
    const [hover, setHover] = useState<any>("")
    const [filterOpen, setFilterOpen] = useState<boolean>(false)
    const [selectCategory, setSelectCategory] = useState<any[]>([])
    const [select, setSelect] = useState<string>("")
    const [searchFocus, setSearchFocus] = useState<boolean>(false)
    const [animation, setAnimation] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)
    const [loading1, setLoading1] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [noSt, setNoSt] = useState<boolean>(true)
    const loaderData: any[] = [1, 2, 3, 4, 5]
    const { t } = useTranslation('common');
    const params = useParams();
    const navigate = useNavigate();
    const isMobile = useDeviceType();

    const colors: any = {
        "transportation": { bg: "bg-[#B75A5A]", focusShadow: "focus:shadow-[0_0_0_2px_#B75A5A5e]", hoverShadow: "hover:shadow-[0_0_0_2px_#B75A5A5e]", text: "text-[#B75A5A]", border: "border-[#B75A5A]" },
        "sports": { bg: "bg-[#5AB788]", focusShadow: "focus:shadow-[0_0_0_2px_#5AB7885e]", hoverShadow: "hover:shadow-[0_0_0_2px_#5AB7885e]", text: "text-[#5AB788]", border: "border-[#5AB788]" },
        "residental": { bg: "bg-[#B7B45A]", focusShadow: "focus:shadow-[0_0_0_2px_#B7B45A5e]", hoverShadow: "hover:shadow-[0_0_0_2px_#B7B45A5e]", text: "text-[#B7B45A]", border: "border-[#B7B45A]" },
        "recreation": { bg: "bg-[#5A5BB7]", focusShadow: "focus:shadow-[0_0_0_2px_#5A5BB75e]", hoverShadow: "hover:shadow-[0_0_0_2px_#5A5BB75e]", text: "text-[#5A5BB7]", border: "border-[#5A5BB7]" },
        "private-offices": { bg: "bg-[#D600C8]", focusShadow: "focus:shadow-[0_0_0_2px_#D600C85e]", hoverShadow: "hover:shadow-[0_0_0_2px_#D600C85e]", text: "text-[#D600C8]", border: "border-[#D600C8]" },
        "nature": { bg: "bg-[#00D62E]", focusShadow: "focus:shadow-[0_0_0_2px_#00D62E5e]", hoverShadow: "hover:shadow-[0_0_0_2px_#00D62E5e]", text: "text-[#00D62E]", border: "border-[#00D62E]" },
        "institutional": { bg: "bg-[#BDD600]", focusShadow: "focus:shadow-[0_0_0_2px_#BDD6005e]", hoverShadow: "hover:shadow-[0_0_0_2px_#BDD6005e]", text: "text-[#BDD600]", border: "border-[#BDD600]" },
        "hotels": { bg: "bg-[#566EE4]", focusShadow: "focus:shadow-[0_0_0_2px_#566EE45e]", hoverShadow: "hover:shadow-[0_0_0_2px_#566EE45e]", text: "text-[#566EE4]", border: "border-[#566EE4]" },
        "commercial": { bg: "bg-[#0097D6]", focusShadow: "focus:shadow-[0_0_0_2px_#0097D65e]", hoverShadow: "hover:shadow-[0_0_0_2px_#0097D65e]", text: "text-[#0097D6]", border: "border-[#0097D6]" },
        "government-offices": { bg: "bg-[#56CAE4]", focusShadow: "focus:shadow-[0_0_0_2px_#56CAE45e]", hoverShadow: "hover:shadow-[0_0_0_2px_#56CAE45e]", text: "text-[#56CAE4]", border: "border-[#56CAE4]" },
        "religious": { bg: "bg-[#E4AE56]", focusShadow: "focus:shadow-[0_0_0_2px_#E4AE565e]", hoverShadow: "hover:shadow-[0_0_0_2px_#E4AE565e]", text: "text-[#E4AE56]", border: "border-[#E4AE56]" },
        "health": { bg: "bg-[#E45656]", focusShadow: "focus:shadow-[0_0_0_2px_#E456565e]", hoverShadow: "hover:shadow-[0_0_0_2px_#E456565e]", text: "text-[#E45656]", border: "border-[#E45656]" },
        "tourist-place": { bg: "bg-[#E45656]", focusShadow: "focus:shadow-[0_0_0_2px_#E456565e]", hoverShadow: "hover:shadow-[0_0_0_2px_#E456565e]", text: "text-[#E45656]", border: "border-[#E45656]" }
    }

    const getPlaceCategory = async () => {
        try {
            setLoading1(true)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.place_category}`);

            if (res && res.status === 200) {
                res?.data?.place_groups?.length > 0 ? setCategory(res?.data?.place_groups) : setCategory([])
                res?.data?.place_groups?.length > 0 ? setData(res?.data?.place_groups) : setData([])
                setSelect(res?.data?.place_groups?.[0]?.id)
                setLoading1(false)
            }
        } catch (error) {
            setLoading1(false)
            console.error("error while fetching place category", error);
        }
    }

    useEffect(() => {
        !!lang && getPlaceCategory();
    }, [lang])

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(search);
        }, 500);

        return () => clearTimeout(timer);
    }, [search]);

    const getPlaces = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const obj: any = {
                "place_type": selectCategory,
                "station": !!params?.code ? [params?.code] : [],
                "search_keyword": debouncedValue
            }
            if (selectCategory?.length > 0 || !!debouncedValue || !!params?.code) {
                const res: any = await useAxios.post(`/${(!!lang ? lang : "en") + url.near_by_places}`, obj);

                if (res && res.status === 200) {
                    setPlacesData(res?.data?.data)
                    setLoading(false)

                    if (res?.data?.message === "No Station Exists") {
                        (!!params?.lang ? navigate(`/${params?.lang}/404`) : navigate("/404"))
                    } else {
                        noSt && sitemap()
                        setNoSt(false)
                    }
                }
            } else {
                const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.near_by_places}`);

                if (res && res.status === 200) {
                    setPlacesData(res?.data?.data)
                    setLoading(false)
                }
            }
        } catch (error) {
            setIsError(true)
            setLoading(false)
            console.error("error while fetching places", error);
        }
    }

    useEffect(() => {
        !!lang && getPlaces();
    }, [lang, selectCategory, debouncedValue])


    useEffect(() => {
        if (window.innerWidth <= 640 && filterOpen) {
            document.body.style.overflow = "hidden";
        } else {
            setFilterOpen(false)
            document.body.style.overflow = "auto";
        }
    }, [window.innerWidth, filterOpen])

    useEffect(() => {
        if (!!select) {
            let arr: any[] = [];
            let arr1: any[] = [];
            for (let i = 0; i < category.length; i++) {
                const el = category[i];

                if (el?.id === select) {
                    arr.push(el)
                } else {
                    arr1.push(el)
                }
            }

            let arr2: any[] = arr.concat(arr1)
            setCategory(arr2)
            setAnimation(true)
        }
    }, [select])

    useEffect(() => {
        if (animation) {
            setTimeout(() => {
                setAnimation(false)
            }, 500)
        }
    }, [animation])

    return (
        <>
            {/* Backdrop */}
            <div>
                <span
                    className={`fixed top-0 left-0 z-20 ${filterOpen ? "block" : "hidden"
                        } h-screen w-full bg-[rgba(216,216,216,0.60)] sm:hidden backdrop-blur-[15px]`}
                    onClick={() => setFilterOpen(!filterOpen)}
                ></span>
            </div>

            <div className=" flex items-center justify-center px-[18px] xlsm:px-[25px] xlx:px-[45px] w-full">
                <div className="h-full py-[33px] grid grid-cols-1 w-[1200px] xlx:w-[1384px]">
                    <div className="w-full flex">
                        <div className="w-[250px] xlx:w-[355px] border-r border-primary border-opacity-[0.2] h-full sm:flex hidden">
                            {/* filter */}
                            <NearPlacesFilter category={category} selectCategory={selectCategory} setSelectCategory={setSelectCategory} mobile={false} colors={colors} data={data} select={select} setSelect={setSelect} animation={animation} loading1={loading1} />
                        </div>

                        <div className="pb-[15px] pt-[5px] xlx:pt-[15px] xlx:pb-[30px] w-full sm:w-[calc(100%-250px)] xlx:w-[calc(100%-355px)] sm:pl-[25px] flex flex-col gap-[20px] xlx:gap-[25px]">
                            <div className="flex md:items-center justify-between w-full md:flex-row flex-col gap-[13px]">
                                <div className="flex items-center justify-between w-full">
                                    <h3 className="text-primaryText dark:text-white font-bold">{(placesData?.length > 0 && (selectCategory?.length > 0 || !!search)) ? `${lang === "en" ? `Showing Result for ${placesData?.length} Filter` : lang === "hi" ? `${placesData?.length} फ़िल्टर के लिए परिणाम दिखाया जा रहा है` : `${placesData?.length} फिल्टरसाठी परिणाम दर्शवित आहे`}` : `${t('passenger.station_detail.nearby_places')}`}</h3>

                                    <button className="bg-white shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] min-w-[40px] h-[40px] rounded-[8px] flex items-center justify-center sm:hidden hover:shadow-[0px_14px_64px_rgba(24,39,75,0.12),0px_8px_22px_rgba(24,39,75,0.12)] focus:shadow-[0px_14px_64px_rgba(24,39,75,0.12),0px_8px_22px_rgba(24,39,75,0.12)] hover:bg-white focus:bg-white border border-transparent focus:border-[#D7D8DD] hover:border-[#D7D8DD] dark:bg-bgDarkDull dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => setFilterOpen(true)}>
                                        <Filter className="xlx:w-auto xlx:h-auto w-[17px] h-[17px] fill-[#1C1B1F] dark:fill-white" />
                                    </button>
                                </div>

                                <div className="flex items-center gap-[10px] md:w-auto w-full justify-end">
                                    <div className={`border dark:border-[rgb(134,134,134,0.3)] border-[rgba(134,134,134,0.15)] h-[40px] xlx:h-[45px] px-[12px] xlx:px-[15px] flex items-center gap-[8px] xlx:gap-[12px] rounded-[12px] w-full xs:w-[315px] ${searchFocus && "shadow-lg dark:border-[#ffffff5e]"} hover:shadow-lg dark:hover:border-[#ffffff5e]`}>
                                        <TableSearch className="xlx:w-[18px] xlx:min-w-[18px] xlx:h-[18px] min-w-[15px] w-[15px] h-[15px] fill-blackDull dark:fill-white opacity-[0.7]" />

                                        <input type="text" className="text-opacity-[0.7] text-blackDull font-medium placeholder:text-blackDull placeholder:text-opacity-[0.7] text-sm leading-snug w-full bg-transparent dark:text-textBlackDull placeholder:dark:text-textBlackDull" placeholder={t("passenger.home.know_st.st.search")} autoComplete="off" value={search} onChange={(e: any) => setSearch(e.target.value)} onFocus={() => setSearchFocus(true)} onBlur={() => setSearchFocus(false)} />
                                    </div>
                                </div>
                            </div>

                            {loading ?
                                <div className="grid grid-cols-1 mmm:grid-cols-2 lgl:grid-cols-3 gap-[20px]">
                                    {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                                        <div key={index} className="border border-gray-200 dark:border-gray-700 shadow rounded-[20px] w-full h-[200px] animate-pulse">
                                            <div className="h-[48px] px-[21px] flex items-center w-full rounded-t-[20px] relative border border-gray-200 dark:border-gray-700 border-b">
                                                <div className="w-[100px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>

                                                <div className='absolute right-[25px] top-[28px]'>
                                                    <div className="rounded-[10px] min-w-[40px] h-[40px] flex items-center justify-center shadow-[0px_2px_4px_-2px_rgba(24,39,75,0.12),0px_4px_4px_-2px_rgba(24,39,75,0.08)] bg-gray-200 dark:bg-gray-700"></div>
                                                </div>
                                            </div>

                                            <div className="flex flex-col justify-between h-[calc(100%-47px)] px-[23px] pt-[37px] pb-[25px]">
                                                <div className="w-[150px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                <div className="w-[100px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                :
                                <>
                                    {isError ? <Error /> : <>
                                        {placesData?.length > 0 && <><div className="grid grid-cols-1 mmm:grid-cols-2 lgl:grid-cols-3 gap-[20px]">
                                            {Array.isArray(placesData) && placesData?.map((item: any, index: number) => (
                                                <div className="w-full h-[200px] relative" key={index}>
                                                    <button className={`${hover === index ? "shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] dark:shadow-[0px_4px_6px_-4px_#ffffff1f,0px_8px_8px_-4px_#ffffff14] border border-transparent h-[330px] relative z-[1] dark:bg-bgDarkDull bg-white near-by-place" : "border dark:border-[#454545] border-[#EDEDED] h-[200px]"} rounded-[20px] w-full near-by-place-card absolute left-0 right-0 top-0 cursor-default`} onMouseEnter={() => setHover(index)} onMouseLeave={() => setHover("")} onFocus={() => !isMobile && setHover(index)} onClick={() => setHover(index)} onBlur={() => setHover(null)}>
                                                        <div className={`h-[48px] px-[21px] flex items-center w-full rounded-t-[20px] ${hover === index ? `${colors[item?.types_of_place?.class_name]?.bg} bg-opacity-[0.1]` : "bg-[#F4F4F4] dark:bg-[#46495370] bg-opacity-[0.65]"} relative`}>
                                                            <p className='uppercase font-semibold text-blackDull dark:text-textBlackDull max-w-[228px] text-xs leading-snug text-left'>{item?.types_of_place?.name}</p>

                                                            <div className='absolute right-[25px] top-[28px]'>
                                                                <div className={`${hover === index ? `${colors[item?.types_of_place?.class_name]?.bg}` : "bg-white shadow-[0px_2px_4px_-2px_rgba(24,39,75,0.12),0px_4px_4px_-2px_rgba(24,39,75,0.08)]"} rounded-[10px] min-w-[40px] h-[40px] flex items-center justify-center`}>
                                                                    <img src={item?.types_of_place?.image?.file} alt={item?.name} className={`${hover === index ? "gates-icon" : ""}`} />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className={`flex flex-col justify-between h-[calc(100%-47px)] px-[23px] ${hover === index ? "py-[25px]" : "pt-[37px] pb-[25px]"}`}>
                                                            <div className='flex flex-col h-full'>
                                                                <div className={`flex flex-col ${hover === index ? "" : "justify-between h-full"}`}>
                                                                    <h5 className='text-blackDark dark:text-textBlackDark font-bold text-left'>{item?.name}</h5>

                                                                    <div className="flex items-center gap-[8px] mt-[25px]">
                                                                        <Station className="fill-blackDull w-[13px] h-[15px] min-w-[13px] dark:fill-textBlackDull" />
                                                                        <h6 className='text-blackDull dark:text-textBlackDull font-medium'>{item?.nearest_metro_station?.name}</h6>
                                                                    </div>

                                                                </div>

                                                                <div className={`flex flex-col ${hover === index ? "opacity-[1]" : "opacity-0 hidden"}`}>
                                                                    <div className='border-b border-primary border-opacity-[0.2] w-full my-[19px]'></div>

                                                                    <div className='flex gap-[25px] w-full'>
                                                                        <div className='flex flex-col gap-[4px] w-[50%]'>
                                                                            <p className='text-primary font-semibold text-left'>{t("passenger.station_detail.near_gate")}</p>
                                                                            {item?.nearest_gate?.length > 0 ? <div className="flex items-center justify-start gap-[4px] flex-wrap">
                                                                                {(Array.isArray(item?.nearest_gate) && item?.nearest_gate?.map((i: any, idx: number) =>
                                                                                    <h5 className="text-blackDull dark:text-textBlackDull font-bold" key={idx}>
                                                                                        {i?.gate_name + `${item?.nearest_gate?.length !== idx + 1 ? ', ' : ' '}`}
                                                                                    </h5>
                                                                                ))}
                                                                            </div> : <h5 className="text-blackDull dark:text-textBlackDull font-bold">-</h5>}
                                                                        </div>

                                                                        <div className='flex flex-col gap-[4px] w-[50%]'>
                                                                            <p className='text-primary font-semibold text-left'>{t("passenger.station_detail.distance_gate")}</p>
                                                                            <h5 className='text-blackDull dark:text-textBlackDull font-bold text-left'>{!!item?.distance_from_metro ? item?.distance_from_metro : "0"} {t("passenger.home.fare.detail.km")}</h5>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className={`${hover === index ? "opacity-[1]" : "opacity-0 hidden"}`}>
                                                                <SecondaryBtn css="!rounded-[6px] font-bold w-full uppercase" title={t("passenger.home.banner.trip_planner.form.plan_journey")} onClick={() => { !!params?.lang ? navigate(`/${params?.lang}/map?to=${item?.nearest_metro_station?.code}&toName=${item?.nearest_metro_station?.name}&toType=station&date=${new Date()}&journey=one_way`) : navigate(`/map?to=${item?.nearest_metro_station?.code}&toName=${item?.nearest_metro_station?.name}&toType=station&date=${new Date()}&journey=one_way`); }} />
                                                            </div>
                                                        </div>
                                                    </button>
                                                </div>
                                            ))}
                                        </div></>}

                                        {((selectCategory?.length === 0 && !!!search) && placesData?.length === 0) &&
                                            <EmptyList />
                                        }

                                        {((selectCategory?.length > 0 || !!search) && placesData?.length === 0) &&
                                            <NoSearch onClick={() => { setSelectCategory([]); setSearch("") }} />
                                        }
                                    </>}
                                </>}
                        </div>
                    </div>
                </div>
            </div>

            <div className={`fixed left-0 right-0 bottom-0 z-50 ${!filterOpen ? "translate-y-full" : ""} h-[500px] w-full bg-white transition duration-400 sm:hidden focus:!outline-none rounded-t-[30px]`}>
                {/* filter */}
                <NearPlacesFilter category={category} selectCategory={selectCategory} setSelectCategory={setSelectCategory} mobile={true} colors={colors} data={data} select={select} setSelect={setSelect} animation={animation} loading1={loading1} />
            </div>
        </>
    );
};

export default NearByPlacesList;